export var errorText = '[react-select-async-paginate] response of "loadOptions" should be an object with "options" prop, which contains array of options.';
export var checkIsResponse = function checkIsResponse(response) {
  if (!response) {
    return false;
  }

  var _ref = response,
      options = _ref.options,
      hasMore = _ref.hasMore;

  if (!Array.isArray(options)) {
    return false;
  }

  if (typeof hasMore !== 'boolean' && typeof hasMore !== 'undefined') {
    return false;
  }

  return true;
};
export var validateResponse = function validateResponse(response) {
  if (!checkIsResponse(response)) {
    // eslint-disable-next-line no-console
    console.error(errorText, 'Received:', response);
    throw new Error(errorText);
  }

  return true;
};